import { authHeaders, trimApiBase } from "./chatApi";

export const ANALYTICS_EVENT_TYPES = [
  "PAGE_VIEW",
  "WIDGET_OPEN",
  "WIDGET_CLOSE",
  "CHAT_START",
  "LEAD_CAPTURE",
  "LINK_CLICK",
  "ACTION_TRIGGERED",
  "SESSION_END",
  "PROACTIVE_SHOWN",
  "PROACTIVE_CLICKED",
  "PROACTIVE_DISMISSED",
  "PROACTIVE_EXPIRED",
  "SESSION_RESUMED",
] as const;

export type AnalyticsEventType = (typeof ANALYTICS_EVENT_TYPES)[number];

export type AnalyticsEventItem = {
  type: AnalyticsEventType;
  timestamp: string;
  url?: string;
  referrer?: string;
  meta?: Record<string, unknown>;
};

function nowIso(): string {
  return new Date().toISOString();
}

export function pageContext(): { url?: string; referrer?: string } {
  const url =
    typeof window !== "undefined" && window.location?.href
      ? window.location.href
      : undefined;
  const referrer =
    typeof document !== "undefined" && document.referrer?.trim()
      ? document.referrer.trim()
      : undefined;
  return { url, referrer };
}

/**
 * POST …/widget/events — `sessionId` is the analytics id from chat/session, not `sessionToken`.
 */
export function ingestEvents(
  apiBase: string,
  siteId: string,
  sessionId: string,
  events: Omit<AnalyticsEventItem, "timestamp">[],
): void {
  if (!events.length) return;
  const body = {
    sessionId,
    events: events.map((e) => ({ ...e, timestamp: nowIso() })),
  };
  const url = `${trimApiBase(apiBase)}/widget/events`;
  void fetch(url, {
    method: "POST",
    credentials: "omit",
    mode: "cors",
    headers: authHeaders(siteId),
    body: JSON.stringify(body),
  }).catch(() => {
    /* non-blocking */
  });
}

export function ingestEvent(
  apiBase: string,
  siteId: string,
  sessionId: string,
  event: Omit<AnalyticsEventItem, "timestamp">,
): void {
  ingestEvents(apiBase, siteId, sessionId, [event]);
}
